import React, { Component } from 'react'
import {mapValues,groupBy} from 'lodash-es';
import initialState from './initialState';
import {proto,url} from '../Helpers/api';
import cores, {getColor} from '../Common/Cores'
import ccFetch from '../Helpers/ccFetch';
/////////////////////////////
// UTILS

// const pipe = (...fns) => initial => fns.reduce((v, f) => f(v), initial);
const pipe = (...functions) => input => functions.reduce(
  (chain, func) => chain.then(func), Promise.resolve(input)
);

const obtemEmpresas = () => (
  ccFetch(`${proto}://${url}/main/empresas`)
)

const getData = () => (
  Promise.all([
    obtemEmpresas(),
  ]).then(res => Promise.all(res.map(r=>r.json())))
    .catch(console.error)
)

const genById = (name,field) => state => {
  return { ...state,
    [`${name}ById`]: mapValues(groupBy(state[name], field), d=>d[0])
  }
}

let x = getColor()
let setCor = () => x.next().value

const obtemData = state => {
  return getData()
    .then(arr => {
      let empresas = arr[0]
      empresas = empresas.map(emp => ({
        ...emp,
        Cor: setCor(),
      }))
      return { ...state, empresas }
    })
    .then(genById("empresas", "Codigo"))
}

//////////////////////////////////////////
// CONTEXT

let context = {
  state: initialState,
  methods: {},
}

export const DataContext = React.createContext(context);

export class DataProvider extends Component {

  state = context.state

  methods = {
    carregaApp: () => {
      pipe(
        // setDefaultUi,
        obtemData,
        // trataCategorias,
      )(initialState).then(state => this.setState(state))
    },
  }

  componentDidUpdate(prevProps) {
    const { user={} } = this.props;
    const { alias } = user;
    const { user:p_user={} } = prevProps;
    const { alias:p_alias } = p_user;
    if (alias !== p_alias) { // se o usuario mudar, precisa recarregar a lista de empresas
      this.methods.carregaApp();
    }
  }
  
  componentDidMount() {
    this.setState(state => ({ ui:  {...state.ui, loading: true }}));
    this.methods.carregaApp();
  }

  render() {
    const { children } = this.props
    return (
      <DataContext.Provider value={{
        data: this.state,
        methods: this.methods
      }}>
        {children}
      </DataContext.Provider>
    )
  }
}

export function withData(Component) {
  return function withDataComponent(props) {
    return (
      <DataContext.Consumer>
        {context => (
          <Component {...props} data={context.data} methods={context.methods} />
        )}
      </DataContext.Consumer>
    );
  }
}

export let DataConsumer = DataContext.Consumer
